<template>
  <div class="pageHeader">
<!--     v-if="this.$route.name !== 'favorite'"-->
    <ul class="mobile_nav text_center" :class="$route.name == 'apps' && 'hasIcon'">
      <router-link to="/workflow/todo" tag="li">
        <!-- <el-badge v-if="itemLength['todo']" :value="itemLength['todo']" class="item"> -->
<!--          <img src="@/assets/images/nav_todo_banner_normal.png"/>-->
        <!-- </el-badge> -->
        <p>待办</p>
      </router-link>
      <router-link to="/workflow/doing" tag="li">
<!--        <img src="@/assets/images/nav_doing_banner_normal.png"/>-->
        <p>已办</p>
      </router-link>
      <router-link to="/workflow/meApply" tag="li">
<!--        <img src="@/assets/images/nav_doing_banner_normal.png"/>-->
        <p>我发起</p>
      </router-link>
      <router-link to="/workflow/done" tag="li">
<!--        <img src="@/assets/images/nav_done_banner_normal.png"/>-->
        <p>办结</p>
      </router-link>
      <router-link to="/workflow/flow_cc" tag="li">
        <!-- <el-badge v-if="itemLength['cc']>0" :value="itemLength['cc']" class="item"> -->
<!--          <img src="@/assets/images/nav_cc_banner_normal.png"/>-->
        <!-- </el-badge> -->
        <p>抄送</p>
      </router-link>
      
      
      <!-- <router-link style="padding-right: 5px" to="/workflow/favorite" tag="li" class="favorite">
        <p>收藏夹</p>
      </router-link> -->
    </ul>
    <div class="search_div text_center"  v-if="this.$route.name !== 'apps'">
      <el-input
          placeholder="请输入事项名称"
          v-model="SearchItem"
          class="appall_search_input_css"
          size="mini"
      >
        <i slot="suffix" style="color: #000;font-size: 17px;" class="el-input__icon el-icon-search" @click="toSearch"/>
      </el-input>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: "CommonNav",
  data() {
    return {
      SearchItem: ""
    };
  },
  computed: {
    itemLength() {
      return this.$store.getters.getDataLength;
    },
  },
  watch: {
    '$route.name': {
      handler(val, oldVal){
        if(val !== oldVal){
          this.SearchItem = null
        }
      }
    },
    SearchItem:{
      handler(val){
        this.toSearch()
      },
    }
  },
  methods: {
    toSearch:_.debounce(function() {
      console.log(this.SearchItem)
      if (this.$route.name == "todo") {
        this.$store.state.apiMap[this.$route.name].query = this.SearchItem;
      } else {
        let val = this.SearchItem;
        this.$store.dispatch("SearchQ", {
          key: this.$route.name,
          property: "keyword",
          val: val,
        })
      }
    }, 300)
  }
};
</script>
<style lang="less" scoped>


</style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/wechat/modules/CommonNav.vue